export const COMPLETE_SIGNUP_MODAL_WIDTH = '421px';
